import React, { useEffect, useState } from 'react'
import totalRide from "../../../assets/imgs/total ride.png"
import paymentPending from "../../../assets/imgs/pending.png"
import paymentFullfilled from "../../../assets/imgs/credit-card-payment.png"

import { TabView, TabPanel } from 'primereact/tabview';
import AllRides from './AllRides';
import { Image } from 'primereact/image';
import PendingPayment from './Pending';
import RecievedPayment from './Recieved';
import { useDispatch, useSelector } from 'react-redux';
import { handleGetRequest } from '../../../services/GetTemplate';

const Payment = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);
    const [paymentHistory, setPaymentHistory] = useState([]);
    const userId = useSelector((state) => state.authenticationSlice?.userId)
    const dispatch = useDispatch();

    const handleTotalRidesClick = () => setActiveIndex(0);
    const handleReceivedClick = () => setActiveIndex(1);
    const handlePendingClick = () => setActiveIndex(2);

    const dataData = [
        {
            _id: "64e5e8cec2f7ef686a3ea8a8",
            method: "zindigi",
            driverStartPoint: {
                longitude: 73.1679556,
                latitude: 33.6181976,
                placeName: "Block C, Gulberg Greens"
            },
            driverEndPoint: {
                longitude: 73.04788479999999,
                latitude: 33.6844202,
                placeName: "Islamabad"
            },
            startPoint: {
                longitude: 73.16809190853489,
                latitude: 33.61827337852977,
                placeName: "J599+88G, Gulberg Greens"
            },
            sendPoint: {
                longitude: 73.04788479999999,
                latitude: 33.6844202,
                placeName: "Islamabad"
            },
            fare: 550,
            status: "unpaid",
            createdAt: "2023-08-23T11:09:02.177Z"
        },
        {
            _id: "64e5e8cec2f7ef686a3ea8a8",
            method: "zindigi",
            driverStartPoint: {
                longitude: 73.1679556,
                latitude: 33.6181976,
                placeName: "Block C, Gulberg Greens"
            },
            driverEndPoint: {
                longitude: 73.04788479999999,
                latitude: 33.6844202,
                placeName: "Islamabad"
            },
            startPoint: {
                longitude: 73.16809190853489,
                latitude: 33.61827337852977,
                placeName: "J599+88G, Gulberg Greens"
            },
            sendPoint: {
                longitude: 73.04788479999999,
                latitude: 33.6844202,
                placeName: "Islamabad"
            },
            fare: 550,
            status: "paid",
            createdAt: "2023-08-23T11:09:02.177Z"
        },
        {
            _id: "64e5e8cec2f7ef686a3ea8a8",
            method: "zindigi",
            driverStartPoint: {
                longitude: 73.1679556,
                latitude: 33.6181976,
                placeName: "Block C, Gulberg Greens"
            },
            driverEndPoint: {
                longitude: 73.04788479999999,
                latitude: 33.6844202,
                placeName: "Islamabad"
            },
            startPoint: {
                longitude: 73.16809190853489,
                latitude: 33.61827337852977,
                placeName: "J599+88G, Gulberg Greens"
            },
            sendPoint: {
                longitude: 73.04788479999999,
                latitude: 33.6844202,
                placeName: "Islamabad"
            },
            fare: 550,
            status: "unpaid",
            createdAt: "2023-08-23T11:09:02.177Z"
        },
        {
            _id: "64e5e8cec2f7ef686a3ea8a8",
            method: "zindigi",
            driverStartPoint: {
                longitude: 73.1679556,
                latitude: 33.6181976,
                placeName: "Block C, Gulberg Greens"
            },
            driverEndPoint: {
                longitude: 73.04788479999999,
                latitude: 33.6844202,
                placeName: "Islamabad"
            },
            startPoint: {
                longitude: 73.16809190853489,
                latitude: 33.61827337852977,
                placeName: "J599+88G, Gulberg Greens"
            },
            sendPoint: {
                longitude: 73.04788479999999,
                latitude: 33.6844202,
                placeName: "Islamabad"
            },
            fare: 550,
            status: "paid",
            createdAt: "2023-08-23T11:09:02.177Z"
        },
        {
            _id: "64e5e8cec2f7ef686a3ea8a8",
            method: "zindigi",
            driverStartPoint: {
                longitude: 73.1679556,
                latitude: 33.6181976,
                placeName: "Block C, Gulberg Greens"
            },
            driverEndPoint: {
                longitude: 73.04788479999999,
                latitude: 33.6844202,
                placeName: "Islamabad"
            },
            startPoint: {
                longitude: 73.16809190853489,
                latitude: 33.61827337852977,
                placeName: "J599+88G, Gulberg Greens"
            },
            sendPoint: {
                longitude: 73.04788479999999,
                latitude: 33.6844202,
                placeName: "Islamabad"
            },
            fare: 550,
            status: "paid",
            createdAt: "2023-08-23T11:09:02.177Z"
        }
    ]
    const getPaymentHistory = async () => {
        const response = await dispatch(handleGetRequest(`api/paymentHistory/driverHistory?userId=${userId}&pageNumber=${pageNumber}`, true, true));
        setPaymentHistory(response?.data);
    };

    useEffect(() => {
        getPaymentHistory()
    }, [])
    const paidData = dataData.filter((item) => item.status === "paid");
    const unpaidData = dataData.filter((item) => item.status === "unpaid");
    return (
        <section>
            <div className="grid ">
                <div className="col-12 xl:col-4 md:col-6 lg:col-6 sm:col-12 mb-3 h-full">
                    <div className="card bg-teal-400 p-5"
                        onClick={handleTotalRidesClick}
                    >
                        <div>
                            <div className="" style={{ width: "5rem", height: "3rem" }} >
                                <Image className="h-full" src={totalRide} width={45} />
                            </div>
                            <div className="flex justify-content-between align-items-end text-white">
                                <h5 className="card-text mt-4 mb-1 text-lg">Total Rides</h5>
                                <h2 className="font-bold mb-0 text-2xl" >0</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 xl:col-4 md:col-6 lg:col-6 sm:col-12 mb-3 h-full">
                    <div className="card bg-green-400 p-5"
                        onClick={handleReceivedClick}
                    >
                        <div>
                            <div className="" style={{ width: "5rem", height: "3rem" }} >
                                <Image className="h-full" src={paymentFullfilled} width={45} />
                            </div>
                            <div className="flex justify-content-between align-items-end text-white">
                                <h5 className="card-text mt-4 mb-1 text-lg">Received</h5>
                                <h2 className="font-bold mb-0 text-2xl" >0</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 xl:col-4 md:col-6 lg:col-6 sm:col-12 mb-3 h-full">
                    <div className="card bg-yellow-400 p-5"
                        onClick={handlePendingClick}
                    >
                        <div>
                            <div className="" style={{ width: "5rem", height: "3rem" }} >
                                <Image className="h-full" src={paymentPending} width={45} />
                            </div>
                            <div className="flex justify-content-between align-items-end text-white">
                                <h5 className="card-text mt-4 mb-1 text-lg">Pending</h5>
                                <h2 className="font-bold mb-0 text-2xl" >0</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="">
                <TabView
                    activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}
                    className='p-3 border-200 border-3 border-round'>
                    <TabPanel header="Total Rides">
                        <AllRides dataData={dataData} />
                    </TabPanel>
                    <TabPanel header="Received">
                        <PendingPayment dataData={paidData} />
                    </TabPanel>
                    <TabPanel header="Pending">
                        <RecievedPayment dataData={unpaidData} />
                    </TabPanel>
                </TabView>
            </div>

        </section>
    )
}

export default Payment